import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryAnimal = () => {
  return <CategoryBase baseEndpoint="category_livestock" environment="DAIRY_CATTLE" />;
};

export default CategoryAnimal;
